import React from 'react';

import CommonModal from '../../../../components/common-modal/CommonModal';
import StepMessageSent from '../../../../contact/components/contact-form/steps/message-sent/StepMessageSent';

import scss from './MessageSentModal.module.scss';

function MessageSentModal({ isOpen, onClose }) {
  return (
    <CommonModal
      isOpen={isOpen}
      onClose={onClose}
      wrapperClassName={scss.wrapper}
      isAnimated
      autoClose={15000}
      animationTimeout={500}>
      <StepMessageSent onClose={onClose} />
    </CommonModal>
  );
}

export default MessageSentModal;
